module.exports = __webpack_public_path__ + "img/knue_gallery6.26589f0e.jpg";